<template>
  <div class="home">
    <!-- <van-button type="danger">危险按钮</van-button> -->
    <!-- <div>{{ path }}</div>
    <br />
    <div>{{ data }}</div>
    <div>结果:{{ result }}</div> -->
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "Home",
  data() {
    return {
      data: "",
      search: "",
      path: "",
      userInfo: null,
      result: {},
      code: "",
      winUrl: "",
    };
  },
  async created() {
    // this.path = window.location.href;
    // this.search = window.location.search;
    // const query = this.getSearchData(window.location.search);
    // this.data = query;
    // await this.getInfo(query);
    // if (Object.keys(this.data).length > 0 && this.userInfo) {
    //   this.toRouter(this.userInfo);
    //   return;
    // }
  },
  mounted() {
    this.getCode();
    // setTimeout(() => {
    //   this.getLocationData();
    // }, 800);
  },
  methods: {
    async getUserInfo(code) {
      let params = {
        code: code,
        fromOfficialAccount: "gh_1d02a42860b1",
      };
      let url = `/healthhubApi/userInfo/wx/getOpenIdByCodeAndOrg`;
      let res = await this.$axios.get(`${url}`, { params });
      if (res.code == 200) {
      }
    },
    getCode() {
      // 非静默授权，第一次有弹框
      this.code = "";
      var local = window.location.href; // 获取页面url
      var appid = "wxa7ba0d8f90d0e72c";
      this.code = this.getUrlCode().code; // 截取code
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        this.getUserInfo(this.code);
        // 你自己的业务逻辑
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    getLocationData() {
      window.xy.ready(() => {
        window.xy.getLocation((res) => {
          this.result = res;
        });
      });
    },
    toRouter(userInfo) {
      if (
        userInfo.extraParameter.indexOf("latitude") != -1 &&
        userInfo.extraParameter.indexOf("longitude") != -1
      ) {
        // 需要携带额外参数
        if (
          JSON.stringify(this.result) != "{}" &&
          this.result.latitude &&
          this.result.longitude
        ) {
          this.$router.replace({
            name: userInfo.routerName,
            query: {
              latitude: this.result.latitude,
              longitude: this.result.longitude,
              path: this.path,
            },
          });
        } else {
          this.toRouter(userInfo);
        }
      } else {
        // 无额外参数
        this.$router.replace({
          name: userInfo.routerName,
        });
      }
    },
    // 获取所需参数
    async getInfo(data) {
      let params = data;
      let url = `https://test.zhuneng.cn/gateway/jb-future/jbfuture/getCaseInfoByTicket`;
      let res = await this.$axios.post(`${url}`, params, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      });
      if (res.code == 200) {
        this.userInfo = res.data;
        let user = {
          assetId: res.data.assetId,
          communityId: res.data.communityId,
          houseId: res.data.houseId,
          orgId: res.data.orgId,
          tenantId: res.data.tenantId,
          userId: res.data.userId,
        };
        this.extraOneMore(user);
      }
    },
    // 更新vuex参数
    extraOneMore(user) {
      sessionStorage.setItem("userInfo", JSON.stringify(user));
      store.commit("setAssetId", user.assetId);
      store.commit("setOpenId", user.openId);
      store.commit("setDefOrgId", user.defOrgId);
      store.commit("setHouseId", user.houseId);
      store.commit("setCommunityId", user.communityId);
      store.commit("setUserId", user.userId);
      store.commit("setTenantId", user.tenantId);
    },
    // location.search 转换为 对象
    getSearchData(search) {
      let obj = {};
      let arr = search.slice(1).split("&");
      arr.forEach((item) => {
        let newArr = item.split("=");
        obj[newArr[0]] = newArr[1];
      });
      return obj;
    },
  },
};
</script>

<style lang="less" scoped></style>
